import { Loader } from './Loader';

export const startTransportingConditionsLoader: { (token?: string): Loader } = (token) =>
  new Loader(token);
